import React from 'react';

class CheckEmail extends React.Component {
   
    render() {
        return (
            <div className="immListDiv" style={{
                backgroundColor: 'white'
            }}>

                <div style={{
                    backgroundColor: 'white', width: '100%', height: '100%', padding: '30px', textAlign: 'center' }}>

                    პაროლის აღდგენის ბმული გადმოგზავნილია თქვენს მეილზე !


                </div>
            </div>

        )
    }
}

export { CheckEmail }; 